var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { attrs: { shadow: "naver" } },
    [_vm._t("card-head"), _vm._t("card-content"), _vm._t("card-footer")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }